// Generated types for TaskResult
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { NeoNodeReadAPI, NeoNodeWriteAPI } from '../../shared/types/neonode';
import { TaskNodeReadAPI } from './tasknode';
import { UserReadAPI } from '../../base/types/user';
import { NeoNodeReadAPISchemaObject, NeoNodeWriteAPISchemaObject } from '../../shared/types/neonode';
import { TaskNodeReadAPISchema } from './tasknode';
import { UserReadAPISchema } from '../../base/types/user';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface TaskResultReadAPI extends NeoNodeReadAPI {
  status: "created" | "running" | "done" | "error";
  details: "input_processing" | "llm_processing" | "output_processing" | "completed";
  task?: TaskNodeReadAPI | null;
  user?: UserReadAPI | null;
  time_stamp?: string | null;
  ellapsed_ms?: number | null;
}

export interface TaskResultWriteAPI extends NeoNodeWriteAPI {
  status: "created" | "running" | "done" | "error";
  details: "input_processing" | "llm_processing" | "output_processing" | "completed";
  task?: TaskNodeReadAPI | null;
  user?: UserReadAPI | null;
  time_stamp?: string | null;
  ellapsed_ms?: number | null;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const TaskResultReadAPISchema: z.ZodType<TaskResultReadAPI> = NeoNodeReadAPISchemaObject.extend({
  status: z.enum(["created", "running", "done", "error"]),
  details: z.enum(["input_processing", "llm_processing", "output_processing", "completed"]),
  task: z.lazy(() => TaskNodeReadAPISchema).nullable().optional(),
  user: z.lazy(() => UserReadAPISchema).nullable().optional(),
  time_stamp: z.string().nullable().optional(),
  ellapsed_ms: z.number().nullable().optional(),
}).passthrough();

export const TaskResultWriteAPISchema: z.ZodType<TaskResultWriteAPI> = NeoNodeWriteAPISchemaObject.extend({
  status: z.enum(["created", "running", "done", "error"]),
  details: z.enum(["input_processing", "llm_processing", "output_processing", "completed"]),
  task: z.lazy(() => TaskNodeReadAPISchema).nullable().optional(),
  user: z.lazy(() => UserReadAPISchema).nullable().optional(),
  time_stamp: z.string().nullable().optional(),
  ellapsed_ms: z.number().nullable().optional(),
}).passthrough();
